import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction, useTheme, Container } from '@mui/material';
import { HiOutlineHome } from "react-icons/hi2";
import { HiHome } from "react-icons/hi2";
import { RiMenuSearchLine } from "react-icons/ri";
import { RiMenuSearchFill } from "react-icons/ri";
import { IoCalendarOutline } from "react-icons/io5";
import { IoCalendar } from "react-icons/io5";
import { BsPersonBadge } from "react-icons/bs";
import { BsPersonBadgeFill } from "react-icons/bs";
import { RiSettingsLine } from "react-icons/ri";
import { RiSettingsFill } from "react-icons/ri";
import { useBookMyOpAuth } from '../contexts/BookMyOpAuthContext';
import { RiHome9Line } from "react-icons/ri";
import { RiHome9Fill } from "react-icons/ri";
import { IoNotificationsOutline } from "react-icons/io5";
import { IoNotifications } from "react-icons/io5";

const MobileBottomNav = ({ onAuthClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useBookMyOpAuth();
  const theme = useTheme();
  // Responsive sizing tuned for Android (rules: 56-72dp height, 20-28dp icons, 10-13sp text)
  const navHeight = 'clamp(64px, 7vh, 72px)';
  const iconSize = 'clamp(20px, 2.2vw, 28px)';
  const labelSize = 'clamp(10px, 2vw, 13px)';
  const selectedLabelSize = 'clamp(11px, 2.3vw, 13px)';
  // Safe-area padding keeps space for gesture bar; scales down on large phones
  const bottomSafePadding = 'calc(env(safe-area-inset-bottom, 0px) + clamp(12px, 3vw, 18px))';
  const innerBottomPadding = 'calc(env(safe-area-inset-bottom, 0px) + clamp(8px, 2vw, 14px))';

  const getIcon = (path) => {
    switch (path) {
      case '/':
        return location.pathname === path ? <RiHome9Fill /> : <RiHome9Line />;
      case '/find-doctors':
        return location.pathname === path ? <RiMenuSearchFill /> : <RiMenuSearchLine />;
      case '/appointments':
        return location.pathname === path ? <IoCalendar /> : <IoCalendarOutline />;
      case '/notifications':
        return location.pathname === path ? <IoNotifications /> : <IoNotificationsOutline />;
      case '/settings':
        return location.pathname === path ? <RiSettingsFill /> : <RiSettingsLine />;
      case '/support':
        return location.pathname === path ? <BsPersonBadgeFill /> : <BsPersonBadge />;
      default:
        return null;
    }
  };

  const handleChange = (event, newValue) => {
    if ((newValue === 'profile' || newValue === 'notifications') && !isAuthenticated) {
      onAuthClick();
      return;
    }
    navigate(newValue);
  };

  return (
    <Paper 
      className="safe-area-bottom"
      sx={{ 
        position: 'fixed', 
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        // pb: bottomSafePadding,
        // pt: '10px',
        // padding: '0 16px 16px 16px',
        display: { xs: 'block', md: 'none' },
        // padding: { xs: '0', md: 2 },
        zIndex: 1000,
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        backdropFilter: 'blur(10px)',
        overflow: 'hidden',
        boxShadow: '0 4px 24px -1px rgba(0, 0, 0, 0.3), 0 0 16px -4px rgba(0, 0, 0, 0.2)',
        // border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '0 !important',
        '& .MuiPaper-root': {
          borderRadius: '0 !important',
        },
        '&.MuiPaper-root': {
          borderRadius: '0 !important',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `linear-gradient(135deg, ${theme.palette.primary.main}20%, ${theme.palette.primary.dark}20%)`,
          zIndex: 0,
          borderRadius: '0 !important',
         
        }
      }}
    >
    
      <BottomNavigation
        value={location.pathname}
        onChange={handleChange}
        showLabels
        sx={{
         
          zIndex: 1,
          position: 'relative',
          height: navHeight,
          minHeight: navHeight,
          padding: `8px 0 ${innerBottomPadding}`,
          display: 'flex',
          justifyContent: 'space-between',
          borderRadius: '0 !important',
         
          '& .MuiBottomNavigationAction-root': {
           borderRadius: '0 !important',
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
            
            
            // minWidth: 'auto',
            flex: 1,
            minHeight: '48px', // touch target rule
            maxWidth: 'none',
            // padding: '8px 12px',
            '& svg': {
              fontSize: iconSize,
              fill: 'white',
              color: 'white',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important'
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '85%',
              height: '85%',
              transform: ' scale(0.8)',
              opacity: 0,
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              // background: `linear-gradient(135deg, ${theme.palette.primary.light}20 0%, ${theme.palette.secondary.light}20 100%)`,
             
              // border: '1px solid rgba(255, 255, 255, 0.2)',
              // boxShadow: '0 4px 12px -2px rgba(0, 0, 0, 0.05)',
              zIndex: -1,
             
            },
            '&.Mui-selected': {
              '&::before': {
                opacity: 1,
                transform: 'scale(1)',
              },
              '& .MuiBottomNavigationAction-label': {
                color: 'white !important',
                fontWeight: 600,
                WebkitTextFillColor: 'white !important',
              },
              '& svg': {
                fill: 'white !important',
                color: 'white !important',
                transform: 'scale(1.1) !important',
                // filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3)) !important',
                fontSize: `calc(${iconSize} + 3px) !important`
              }
            }
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: labelSize,
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            marginTop: '4px',
            color: 'white',
            whiteSpace: 'nowrap',
            '&.Mui-selected': {
              fontSize: selectedLabelSize
            }
          }
        }}
      >
        <BottomNavigationAction 
          label="Home" 
          value="/" 
          icon={getIcon('/')} 
        />
        <BottomNavigationAction 
          label="Search" 
          value="/find-doctors" 
          icon={getIcon('/find-doctors')} 
        />
        <BottomNavigationAction 
          label="Appointments" 
          value="/appointments" 
          icon={getIcon('/appointments')} 
        />
          <BottomNavigationAction 
            label="Support" 
            value="/support" 
            icon={getIcon('/support')} 
          />
        <BottomNavigationAction 
          label="Settings" 
          value="/settings" 
          icon={getIcon('/settings')} 
        />
       
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav; 